import * as React from "react";

import { Button } from "./Button";

const PrimaryButton = ({ ...rest }) => (
  <Button skin="primary" {...rest} />
);

export default PrimaryButton;
